import React from "react";
import { StoreContext } from "../../../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../../../withRouter";
import config from "../../../config";
import { shouldShowComponent } from "../../../utils/componentVisibility";
import { hasFeature } from "../../../utils/componentVisibility";
import conf from "../../../config";

const shareToWhatsApp = () => {
    window.open(
        `https://api.whatsapp.com/send/?phone=${'+966115003419'}&text&type=phone_number&app_absent=0`
    );
};

const features = {
    raiseTicket: hasFeature("raiseTicket")
};

const AWTLHelpSection = (props) => {
    const shouldShow = shouldShowComponent(config.project, "AWTLHelpSection");

    const raiseTicket = () => {
        window.open(
            config.NodeCoreUrl + "/ticket/request",
            "_blank"
        );
    };

    if (!shouldShow) {
        return null; // Do not render if the condition is not met
    }

    return (
        <>



            <div
                style={{
                    position: "fixed",
                    bottom: "15px",
                    right: "10px",
                    zIndex: 9999,
                }}
            >

                {features.raiseTicket && (
                    <div
                        onClick={raiseTicket}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            width: "185px",
                            height: "50px",
                            background: "#0066cc",
                            borderRadius: "32px",
                            color: "#fff",
                            cursor: "pointer",
                            padding: "0 18px",
                            marginBottom: "10px",
                        }}
                    >
                        <i
                            style={{
                                fontSize: "24px",
                                minWidth: "24px",
                                display: "flex",
                                justifyContent: "center",
                            }}
                            className="bi bi-ticket-perforated"
                        ></i>

                        <span
                            style={{
                                flex: 1,
                                textAlign: "center",
                                fontSize: "16px",
                                fontWeight: 500,
                            }}
                        >
                            Raise a Ticket
                        </span>
                    </div>
                )}

                <div
                    onClick={() => shareToWhatsApp()}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        width: "185px",
                        height: "50px",
                        background: "#2dbd0f",
                        borderRadius: "32px",
                        color: "#fff",
                        cursor: "pointer",
                        padding: "0 18px",
                        marginBottom: "10px",
                    }}
                >
                    <i
                        style={{
                            fontSize: "24px",
                            minWidth: "24px",
                            display: "flex",
                            justifyContent: "center",
                        }}
                        class="bi bi-whatsapp"></i>
                    <span
                        style={{
                            flex: 1,
                            textAlign: "center",
                            fontSize: "16px",
                            fontWeight: 500,
                        }}>
                        Need help?
                    </span>
                </div>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        width: "185px",
                        height: "50px",
                        background: "#f10000",
                        borderRadius: "32px",
                        color: "#fff",
                        cursor: "pointer",
                        padding: "0 18px",
                    }}
                >
                    <i style={{
                        fontSize: "24px",
                        minWidth: "24px",
                        display: "flex",
                        justifyContent: "center",
                    }}
                        class="bi bi-headset"></i>
                    <span
                        style={{
                            flex: 1,
                            textAlign: "center",
                            fontSize: "16px",
                            fontWeight: 500,
                        }}
                    >+966115003419
                    </span>
                </div>
            </div>
        </>
    );
};

AWTLHelpSection.contextType = StoreContext;
export default observer(withRouter(AWTLHelpSection));